import React, { FC, ReactNode } from "react";
import { Checkbox, ListItemText, MenuItem } from "@mui/material";
import { capitalize } from "lodash";
import { useField } from "formik";
import { CustomFieldSelect } from "../../../components/fields/CustomFieldSelect";

interface Option {
  label: string;
  value: string | number;
}

interface Props {
  renderValue?: (value: Array<string | number>) => ReactNode;
  name: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  options: Array<string | Option>;
  disabled?: boolean;
}

export const CustomSelectFieldLabel: FC<Props> = ({
  label,
  required = true,
  options,
  placeholder,
  disabled,
  ...rest
}) => {
  const [field] = useField(rest.name);
  return (
    <CustomFieldSelect
      {...rest}
      multiple={!!rest.renderValue}
      label={label || capitalize(rest.name)}
      fullWidth
      required={required}
      placeholder={placeholder || "Select"} 
      value={field.value || ""} 
      disabled={disabled}
    >
      {options.map((option, index) => {
        const isObject = typeof option === "object";
        const value = isObject ? option.value : option;
        const displayLabel = isObject ? option.label : option;

        // if (rest.renderValue)
        //   return (
        //     <MenuItem value={displayLabel} key={index}>
        //       <Checkbox checked={field.value.indexOf(displayLabel) > -1} />
        //       <ListItemText primary={displayLabel} />
        //     </MenuItem>
        //   );

        return (
          <MenuItem value={displayLabel} key={index}>
            {displayLabel}
          </MenuItem>
        );
      })}
    </CustomFieldSelect>
  );
};
